
import {Component, Mixins, Prop} from "vue-property-decorator";
import {mask} from "vue-the-mask";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";
import {ParaBirimi} from "@/enum/ParaBirimi";

@Component({
  components: {
    DatabasePicker,
  },
  directives: {
    mask,
  },
})
export default class ParaBirimiPicker extends Mixins(SimpleInputMixin) {
  @Prop() returnId!: boolean;
  @Prop() label!: string;
  @Prop({}) rules!: string;
  @Prop() readonly !: string | boolean;
  @Prop() hideDetails !: string | boolean;
  @Prop({default: true}) defaultFirst !: boolean;
  @Prop({default: false}) defaultParaBirimi !: boolean;
  @Prop() clearable !: string | boolean;

  get isReadonly() {
    return this.readonly || this.readonly === "";
  }

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  get isClearable() {
    return this.clearable || this.clearable === "";
  }

  /** Takip (takipEkle/takipDetay) talepler[0].takip_alt_tipi.para_birimi_id; sadece defaultParaBirimi ve value boşken. */
  get defaultParaBirimiId(): number | undefined {
    if (!this.defaultParaBirimi || this.value != null && this.value !== "") {
      return undefined;
    }
    const storeName = this.$helper.getTakipStoreName(this.$route.path);
    const takipBilgileri = this.$helper.getTakipBilgileri(this.$store.state, storeName);
    const id = takipBilgileri?.talepler?.[0]?.takip_alt_tipi?.para_birimi_id;
    return typeof id === "number" ? id : ParaBirimi.TRY;
  }

  /** Takip varsayılanı kullanılıyorsa defaultFirst devre dışı. */
  get effectiveDefaultFirst(): boolean {
    if (this.defaultParaBirimi) return false;
    const df = this.defaultFirst as boolean | string;
    return !this.defaultParaBirimiId && (df === true || df === "");
  }

  onParaBirimiChange(paraBirimi: ParaBirimiEntity) {
    this.$emit('para-birimi', paraBirimi);
    this.input();
  }
}
